import { dispatch } from "../store/store";
import { logError } from "../services/logService";
import {
  getCompanyDetailsData,
  setIsBookingLoading,
  getPharmacyServiceAvailibilityData,
  getServiceBookingSlotsData,
  setBookingModelData,
  updateBookingFieldData,
  setSelectedServiceBookingSlotData,
  createRyftSessionData,
  createPaymentAuditData,
  setSelectedBranchData,
  getAllServicesByCompanyIdData,
  setSelectedPrivateServiceData,
  getPharmacyByServiceData,
  setCurrentCompanyIdData,
  getCompanyMarketAppAccountIdByCompanyIdData,
  getPatientConsultationData,
  getPaymentViaLinkData,
} from "../features/templateSectionSlice/bookingSlice/bookingSlice";

const reducerName = "bookingSection";

export const setBookingLoading = (isLoading) => {
  dispatch(setIsBookingLoading(isLoading));
};
export const setBookingModel = (data) => {
  dispatch(setBookingModelData(data));
};
export const updateBookingField = (data) => {
  dispatch(updateBookingFieldData(data));
};
export const setSelectedServiceBookingSlot = (data) => {
  dispatch(setSelectedServiceBookingSlotData(data));
};
export const setSelectedBranch = (data) => {
  dispatch(setSelectedBranchData(data));
};
export const setSelectedPrivateService = (data) => {
  dispatch(setSelectedPrivateServiceData(data));
};
export const setCurrentCompanyId = (data) => {
  dispatch(setCurrentCompanyIdData(data));
};


export const getCompanyDetails = async (params) => {
  let result = null;
  try {
    result = await dispatch(getCompanyDetailsData(params)).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }
  return result;
};

export const getPharmacyServiceAvailibility = async (params) => {
  let result = null;
  try {
    result = await dispatch(
      getPharmacyServiceAvailibilityData(params)
    ).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }
  return result;
};

export const getServiceBookingSlots = async (params) => {
  let result = null;
  try {
    result = await dispatch(getServiceBookingSlotsData(params)).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }
  return result;
};

export const createRyftSession = async (params) => {
  let result = null;
  try {
    result = await dispatch(createRyftSessionData(params)).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }
  return result;
};

export const createPaymentAudit = async (params) => {
  let result = null;
  try {
    result = await dispatch(createPaymentAuditData(params)).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }
  return result;
};

export const getAllServicesByCompanyId = async (params) => {
  let result = null;
  try {
    result = await dispatch(getAllServicesByCompanyIdData(params)).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }
  return result;
};

export const getPharmacyByService = async (params) => {
  let result = null;
  try {
    result = await dispatch(getPharmacyByServiceData(params)).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }
  return result;
};

export const getCompanyMarketAppAccountIdByCompanyId = async (params) => {
  let result = null;
  try {
    result = await dispatch(getCompanyMarketAppAccountIdByCompanyIdData(params)).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }
  return result;
};

export const getPatientConsultation = async (params) => {
  let result = null;
  try {
    result = await dispatch(getPatientConsultationData(params)).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }
  return result;
};

export const getPaymentViaLinkDetails = async (params) => {
  let result = null;
  try {
    result = await dispatch(getPaymentViaLinkData(params)).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }
  return result;
};
